// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Naei","newExpiryDate":"styles_newExpiryDate__3HQbA","footer":"styles_footer__2fK1J"};